import { StaffAssignDetailResponseType } from '../staffAssign/types';

import {
  ImportDataRequestType,
  ImportDataResponseType,
  OCRRequestDataTypes,
  OCRResponseDataTypes,
  StaffProjectResponse,
  StaffRequestType,
  StaffResponseType
} from './types';

import axiosInstance from 'common/services/common/instance';

export const getAllStaffService = async (
  params?: BaseFilterParams,
): Promise<APIPaginationResponse<Array<StaffResponseType>>> => {
  const res = await axiosInstance.get('staffs', { params });
  return res.data;
};

export const getStaffService = async (
  id: number,
): Promise<StaffResponseType> => {
  const res = await axiosInstance.get(`staffs/${id}`);
  return res.data.data;
};

export const deleteStaffService = async (
  ids: number[],
): Promise<void> => {
  await axiosInstance.delete('staffs', { data: { ids } });
};

export const createStaffService = async (
  params: StaffRequestType,
): Promise<void> => {
  await axiosInstance.post('staffs', params);
};

export const updateStaffService = async (
  params: { id: number, data: StaffRequestType },
): Promise<void> => {
  await axiosInstance.put(`staffs/${params.id}`, params.data);
};

export const ocrStaffInfoService = async (data: OCRRequestDataTypes):
  Promise<OCRResponseDataTypes> => {
  const res = await axiosInstance.post('staffs/ocr/get-data', data);
  return res.data;
};

export const getInfoByExistedIdCard = async (idCardNumber: string):
  Promise<StaffResponseType | StaffAssignDetailResponseType> => {
  const res = await axiosInstance.get(`staffs/find-by-id-card/${idCardNumber}`);
  return res.data.data;
};

export const importStaffService = async (
  params: ImportDataRequestType,
): Promise<ImportDataResponseType> => {
  const bodyForm = new FormData();
  bodyForm.append('file', params.file);
  bodyForm.append('preview', params.preview ? '1' : '0');

  const res = await axiosInstance.post('staffs/import', bodyForm);
  return res.data.data;
};

export const importStaffTemplateService = async (): Promise<{ link: string }> => {
  const res = await axiosInstance.post('staffs/import-template');
  return res.data.data;
};

export const printStaffService = async (
  staffId: number,
): Promise<{
  link: string;
}> => {
  const res = await axiosInstance.post(`staffs/${staffId}/print-contract`);
  return res.data.data;
};

export const exportStaffService = async (params?: any): Promise<{ link: string }> => {
  const res = await axiosInstance.post('exports/staffs', null, { params });
  return res.data.data;
};

export const getProjectStaffService = async (
  ids: number[],
): Promise<StaffProjectResponse[]> => {
  const res = await axiosInstance.post('staffs/get-project', { ids });
  return res.data.data;
};
